<template>
  <div
    class="d-flex px-2 col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 projects"
  >
    <div class="flex-grow-1 p-0">
      <div class="d-flex justify-content-start">
        <div class="dropdown">
          <button
            class="btn btn-secondary dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-funnel-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"
              />
            </svg>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <router-link class="dropdown-item" :to="{ name: 'dashboard' }"
              >By Tracks</router-link
            >
            <router-link class="dropdown-item" :to="{ name: 'projects' }"
              >By Projects</router-link
            >
          </div>
        </div>
      </div>
      <div class="card-body-track m-0 p-0">
        <div
          class="d-flex flex-column mid-height pl-2 t-list"
          id="projectList"
          style="overflow: auto"
        >
          <div v-for="project in apiEvents.userProjects" :key="project.id">
            <ProjectCard :name="project.name" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
//import TrackItem from "@/components/TrackItem.vue";
import ProjectCard from "@/components/ProjectCard.vue";
export default {
  computed: {
    ...mapState(["apiEvents"]),
  },

  components: {
    // TrackItem
    ProjectCard,
  },
};
</script>

<style scoped>
.trackText {
  color: #fff;
  font-size: 15px;
  font-family: "Open Sans";
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 1.5px;
}
</style>
